import type { ParameterConfig } from '@/types/measurements';

import type { IIndicatorNorms } from '../Pages/SinglePatientDetails/Service/overview/types';
import type { INormV2 } from '../services/normsServiceV2/types';
import { getParameterUnit, transformParameter } from './parametersUtil';

export const getParameterNorm = (norms: INormV2[], paramKey: string): IIndicatorNorms => {
  return (
    norms?.find(({ key }) => key?.toLowerCase() === paramKey?.toLowerCase())?.norm ??
    ({} as IIndicatorNorms)
  );
};

export const transformNormData = (
  parameterConfigs: ParameterConfig[],
  normData: IIndicatorNorms,
  paramKey: string,
  isImperial: boolean,
) => ({
  ...normData,
  lowLimit: transformParameter(parameterConfigs, paramKey, normData.lowLimit, isImperial),
  highLimit: transformParameter(parameterConfigs, paramKey, normData.highLimit, isImperial),
  parts: normData?.parts?.map((part) => ({
    ...part,
    start: transformParameter(parameterConfigs, paramKey, part.start, isImperial),
    end: transformParameter(parameterConfigs, paramKey, part.end, isImperial),
  })),
  units: getParameterUnit(parameterConfigs, paramKey, normData.units, isImperial),
});
